import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import themeService from "@/services/theme";
import sitesService from "@/services/site";
import areaService from "@/services/area";
import devicesService from "@/services/device";

export const useThemeAssignmentsStore = defineStore("themeAssignments", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchThemeAssignmentsGrid(payload) {
    loading.value = true;
    try {
      const res = await themeService.getThemeAssignmentsGrid(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function assignTheme(payload) {
    loading.value = true;
    try {
      const res = await themeService.assignTheme(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editThemeAssignment(payload) {
    loading.value = true;
    try {
      const res = await themeService.editThemeAssignment(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function activateThemeAssignment(payload) {
    loading.value = true;
    try {
      const res = await themeService.activateThemeAssignment(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteThemeAssignment(payload) {
    loading.value = true;
    try {
      const res = await themeService.deleteThemeAssignment(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchSitesBySearch(payload) {
    loading.value = true;
    try {
      const res = await sitesService.getSitesBySearch(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchStoresBySearch(payload) {
    loading.value = true;
    try {
      const res = await sitesService.getStoresBySearch(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchAreasBySearch(payload) {
    loading.value = true;
    try {
      const res = await areaService.getAreasBySearch(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchDevicesBySearch(payload) {
    loading.value = true;
    try {
      const res = await devicesService.getDevicesBySearch(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchThemeAssignmentsGrid,
    assignTheme,
    editThemeAssignment,
    activateThemeAssignment,
    deleteThemeAssignment,
    fetchSitesBySearch,
    fetchStoresBySearch,
    fetchAreasBySearch,
    fetchDevicesBySearch,
  };
});
